import { NavLink } from 'react-router-dom';
import { can } from '../../auth/permissions';
import { useAppSelector } from '../../hooks/redux';

const groups = [
  { label: 'Catalog', items: [['/products', 'Products', 'products.read'], ['/categories', 'Categories', 'categories.read'], ['/units-of-measure', 'Units of Measure', 'units_of_measure.read']] },
  { label: 'Commercial', items: [['/customers', 'Customers', 'customers.read'], ['/suppliers', 'Suppliers', 'suppliers.read']] },
  { label: 'Purchasing', items: [['/purchases', 'Purchases', 'purchases.read'], ['/goods-receipts', 'Goods Receipts', 'goods_receipts.read']] },
  { label: 'Warehouse', items: [['/inventory', 'Inventory', 'inventory.read'], ['/inventory-adjustments', 'Inventory Adjustments', 'inventory.read']] },
  { label: 'Sales', items: [['/sales', 'Sales', 'sales.read']] },
  { label: 'Administration', items: [['/users', 'Users', 'users.read'], ['/roles', 'Roles', 'users.read'], ['/permissions', 'Permissions', 'users.read'], ['/warehouses', 'Warehouses', 'warehouses.read']] },
];

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

export function Sidebar({ isOpen, onClose }: SidebarProps) {
  const permissions = useAppSelector((state) => state.auth.user?.permissions ?? []);
  const visibleGroups = groups.map((group) => ({
    ...group,
    items: group.items.filter(([, , permission]) => can(permission, permissions)),
  })).filter((group) => group.items.length > 0);

  return (
    <aside className={`sidebar${isOpen ? ' sidebar--open' : ''}`} id="main-navigation">
      <div className="sidebar-header">
        <div className="brand">ERP<span>.</span></div>
        <button aria-label="Close navigation menu" className="sidebar-close" type="button" onClick={onClose}>
          <svg aria-hidden="true" viewBox="0 0 24 24">
            <path d="m6 6 12 12M18 6 6 18" />
          </svg>
        </button>
      </div>
      <nav aria-label="Main navigation">
        {visibleGroups.map((group) => (
          <div className="nav-group" key={group.label}>
            <p className="nav-group__label">{group.label}</p>
            {group.items.map(([path, label]) => (
              <NavLink className={({ isActive }) => `nav-link${isActive ? ' nav-link--active' : ''}`} to={path} key={path} onClick={onClose}>{label}</NavLink>
            ))}
          </div>
        ))}
      </nav>
    </aside>
  );
}
